import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "app/service/auth/auth.service";
import { ShareService } from "app/service/share/share.service";
import { saveAs } from 'file-saver';
import * as moment from "moment";
import { CreditCharge, Member } from "../../service/member/member";
import { MemberService } from "../../service/member/member.service";

@Component({
  selector: 'app-credit-board',
  templateUrl: './credit-board.component.html',
  styleUrls: ['./credit-board.component.scss'],
  providers: [ShareService, MemberService]
})
export class CreditBoardComponent {
  me: Member;
  credit: CreditCharge;
  history: any = {};
  page: number;
  startTime: string;
  endTime: string;
  monthArr: number[] = [];

  constructor(private shareService: ShareService,
    private memberService: MemberService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,) {
    this.shareService.awaitMe().subscribe(
      me => {
        this.me = me;
      }
    );

    this.memberService.getCreditCharge().subscribe(
      credit => this.credit = { ...this.credit, ...credit }
    )

    this.shareService.awaitCredit().subscribe(
      credit => this.credit = { ...this.credit, ...credit }
    )

    this.route.queryParams.subscribe(
      params => {
        this.page = params['page'] ? +params['page'] : 1;
        this.startTime = params['startTime'] ? params['startTime'] : moment().subtract(1, 'month').format('YYYY-MM-DD');
        this.endTime = params['endTime'] ? params['endTime'] : moment().format('YYYY-MM-DD');
        this.active = params['startTime'] && params['endTime'] ?
          moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month') + '' : '1';

        this.getHistory();
      }
    );

    const month = moment().month();
    this.monthArr = [
      month - 1 > 0 ? month - 1 : 12 - month - 1,
      month > 0 ? month : 12 - month,
      month + 1
    ];
  }

  getHistory() {
    this.memberService.getCreditHistory(this.page, this.startTime, this.endTime).subscribe(
      res => {
        this.history = res
      }
    )
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(
      `${url}?` +
      (this.page ? `page=${this.page}` : '') +
      (this.startTime ? `&startTime=${this.startTime}` : '') +
      (this.endTime ? `&endTime=${this.endTime}` : '')
    );
  }

  onSearch() {
    this.active = moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month') + '';
    this.reload();
  }

  active: string;
  onActive(active: string) {
    this.active = active;

    if (active === '1') {
      this.startTime = moment().subtract(1, 'month').format('YYYY-MM-DD');
      this.endTime = moment().format('YYYY-MM-DD');
    }
    else if (active === '2') {
      this.startTime = moment().subtract(2, 'month').format('YYYY-MM-DD');
      this.endTime = moment().format('YYYY-MM-DD');
    }
    else if (active === '6') {
      this.startTime = moment().subtract(6, 'month').format('YYYY-MM-DD');
      this.endTime = moment().format('YYYY-MM-DD');
    }

    this.reload();
  }

  onPageChanged(event: any) {
    if (event.page == this.page) return;

    this.page = event.page;
    this.reload();
  }

  isDeduct() {
    if (this.credit) return this.credit.credit > 0
    else return false
  }

  get isAdmin() {
    return this.authService.isAdmin();
  }

  downloadCredit(midx) {
    const { team, location } = this.me;
    const date = moment();
    const month = this.monthArr[midx];
    let year = date.year();

    const nowMonth = moment().month();
    if (nowMonth === 0 && (midx < 2)) {
      year = year - 1;

    } else if (nowMonth === 1 && (midx < 1)) {
      year = year - 1;
    }

    this.memberService.getCreditFile(team.code, location.key, year, month).subscribe(res => {
      let fileBlob = res.blob();
      let blob = new Blob([fileBlob]);

      let filename = `credit_${year}_${month}.xls`;
      saveAs(blob, filename);
    });
  }


  pricePopup = {
    show: false,
  }
  get CreditPrice() {
    const price = this.credit.price || 0;
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  get NewCreditPrice() {
    const price = this.credit.newPrice || 0;
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}



// WEBPACK FOOTER //
// ./src/app/member/credit-board/credit-board.component.ts